<template>
  <v-lazy style="min-width: 0" :options="{ threshold: 0.5 }" @update:model-value="onVisible">
    <div>
      <AGTooltip :activator-class="tooltipActivatorClass" :tooltip-text="text" :disabled="!isTruncated || hideTooltip">
        <div class="ag-truncated-text" :class="contentClass" v-html="text" />
      </AGTooltip>
    </div>
  </v-lazy>
</template>

<script>
import AGTooltip from '@/components/common/AGTooltip.vue';

export default {
  components: {
    AGTooltip,
  },

  props: {
    text: {
      type: [String, Number],
      default: '-',
    },

    hideTooltip: {
      type: Boolean,
      default: false,
    },

    tooltipActivatorClass: {
      type: String,
      default: 'ag-truncated-text__tooltip_activator',
    },

    contentClass: {
      type: [String, Function, Object],
      default: '',
    },
  },

  data: () => ({
    isTruncated: false,
  }),

  methods: {
    onVisible() {
      this.$nextTick().then(() => {
        const el = this.$el.getElementsByClassName('ag-truncated-text');
        this.isTruncated = el[0].clientWidth < el[0].scrollWidth;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-truncated-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
</style>
